// import { useAppDispatch } from '@/shared/hooks/store';
// import { Player as LottiePalyer } from '@lottiefiles/react-lottie-player';
import { FC } from 'react';
import LottiePalyer from 'react-lottie-player';

import { Button } from '@/shared/ui';

interface IntroductionPureProps {
    src: { ['default']: object } | object;
    loop?: boolean;
    className?: string;
    onSkip(): void;
    onPlayStart?(): void;
    onPlayComplete?(): void;
}

interface IntroductionProps extends IntroductionPureProps {}

export const Introduction: FC<IntroductionProps> = ({ src, onSkip, loop = false, className }) => {
    return (
        <div data-testid="introduction-container" className={`onboarding-introduction-container relative h-full w-full flex-1 ${className}`}>
            <div data-testid="introduction-player" className="flex h-full w-full justify-center">
                <LottiePalyer onComplete={onSkip} play animationData={src} loop={loop} />
            </div>
            <Button
                onClick={onSkip}
                variant="text"
                className="fixed right-0 bottom-[190px] z-10 sm:bottom-[210px] w-[70px] sm:right-[5px] lg:bottom-[80px]"
                testId="button-introduction-skip"
            >
                Skip
            </Button>
        </div>
    );
};

export const IntroductionPure: FC<IntroductionPureProps> = ({ src, onSkip = () => {}, loop = false, onPlayComplete = () => {} }) => {
    return (
        <div data-tesitd="introduction-pure-container" className="onboarding-introduction-container relative h-full w-full flex-1">
            <div data-testid="introduction-pure-player" className="flex h-full w-full justify-center">
                {<LottiePalyer onComplete={onPlayComplete} animationData={src} loop={loop} />}
            </div>
            <Button testId="button-introduction-pure-skip" onClick={onSkip} variant="text" className="onboarding-skip-btn absolute bottom-10 right-10 z-10">
                Skip
            </Button>
        </div>
    );
};

export default Introduction;
